import { render, staticRenderFns } from "./EcoLabware.vue?vue&type=template&id=71b9368c"
import script from "./EcoLabware.vue?vue&type=script&lang=js"
export * from "./EcoLabware.vue?vue&type=script&lang=js"
import style0 from "./EcoLabware.vue?vue&type=style&index=0&id=71b9368c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports